export default {
  setEventId (state, eventId) {
    state.eventId = eventId
  },

  setEventQuizset (state, eventQuizset) {
    state.eventQuizset = eventQuizset
  },

  setQuizset (state, quizset) {
    state.quizset = quizset
  },

  setQuizsets (state, quizsets) {
    state.quizsets = quizsets
  }
}
